import { Dispatch } from "redux"

export const OPEN_MODAL = "OPEN_MODAL"
export const CLOSE_MODAL = "CLOSE_MODAL"

export function changeModalState(isOpen: boolean, type: App.ModalTypes = "", metadata?: unknown) {
  return (dispatch: Dispatch) => {
    if (isOpen) return dispatch({ type: OPEN_MODAL, payload: { type, metadata } })

    return dispatch({ type: CLOSE_MODAL })
  }
}
